import { render, staticRenderFns } from "./WidgetTitle.vue?vue&type=template&id=1aa8cae6&scoped=true&"
import script from "./WidgetTitle.vue?vue&type=script&lang=js&"
export * from "./WidgetTitle.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTitle.vue?vue&type=style&index=0&id=1aa8cae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa8cae6",
  null
  
)

export default component.exports